import { createAction, props } from '@ngrx/store';
import { MiniUserModel } from '../../../shared/data/models/mini-user.model';
import { ProfileUpdateInput } from '../../../shared/data/inputs/profile-update.input';
import { FollowUnFollowUserInput } from '../../../shared/data/inputs/follow-un-follow-user.input';
import { CreateLinkInput } from '../../../shared/data/inputs/create-link.input';

export const loadMeAsProfileUser = createAction(
  '[Profile] Load Me As Profile User'
);

export const loadProfileUser = createAction(
  '[ProfileUser] Load Profile User',
  props<{ handleName: string }>()
);

export const loadProfileUserSuccess = createAction(
  '[ProfileUser] Load Profile User Success',
  props<{ profileUser: MiniUserModel }>()
);

export const loadProfileUserError = createAction(
  '[ProfileUser] Load Profile User Error',
  props<{ error: string }>()
);

/**
 * update profile data
 * */
export const updateProfile = createAction(
  '[ProfileUser] Update Profile',
  props<{ payload: ProfileUpdateInput }>()
);

export const updateProfileSuccess = createAction(
  '[ProfileUser] Update Profile Success',
  props<{ payload: MiniUserModel }>()
);

export const updateProfileError = createAction(
  '[ProfileUser] Update Profile Error',
  props<{ payload: string }>()
);

/**
 * follow or un follow someone
 * */
export const followUserAction = createAction(
  '[ProfileUser] Follow User Action',
  props<{ payload: FollowUnFollowUserInput }>()
);

export const unFollowUserAction = createAction(
  '[ProfileUser] Un Follow User Action',
  props<{ payload: FollowUnFollowUserInput }>()
);

export const followUnFollowSuccessAction = createAction(
  '[ProfileUser] Follow or UnFollow Success Action',
  props<{ modifiedUser: MiniUserModel }>()
);

export const followUnFollowErrorAction = createAction(
  '[ProfileUser] Follow or UnFollow Error Action',
  props<{ error: string }>()
);

// upload profile image
export const uploadProfileImage = createAction(
  '[ProfileUser] upload profile image',
  props<{ payload: { input: CreateLinkInput; file: File; path: string } }>()
);

export const uploadProfileImageSuccess = createAction(
  '[ProfileUser] upload profile image success'
);

export const uploadProfileImageError = createAction(
  '[ProfileUser] upload profile image error',
  props<{ error: string }>()
);

// upload cover photo
export const uploadProfileCoverImage = createAction(
  '[ProfileUser] upload profile cover image',
  props<{ payload: { input: CreateLinkInput; file: File; path: string } }>()
);

export const uploadProfileCoverImageSuccess = createAction(
  '[ProfileUser] upload profile cover image success'
);

export const uploadProfileCoverImageError = createAction(
  '[ProfileUser] upload profile cover image error',
  props<{ error: string }>()
);

// remove the profile images
export const removeProfileImage = createAction(
  '[ProfileUser] remove profile image'
);

export const removeProfileImageSuccess = createAction(
  '[ProfileUser] remove profile image Success'
);

export const removeProfileImageError = createAction(
  '[ProfileUser] remove profile image error',
  props<{ error: string }>()
);

// remove cover photo
export const removeProfileCoverImage = createAction(
  '[ProfileUser] remove profile cover image'
);

export const removeProfileCoverImageSuccess = createAction(
  '[ProfileUser] remove profile cover image Success'
);

export const removeProfileCoverImageError = createAction(
  '[ProfileUser] remove profile cover image error',
  props<{ error: string }>()
);
